import React from "react";

type Props = {
  label: string;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const ToggleButton: React.FC<Props> = ({ label, handleChange }) => {
  return (
    <div className="toggle-container">
      <label htmlFor="siteToggle" className="toggle-label">
        {label}
      </label>
      <input id="siteToggle" type="checkbox" onChange={handleChange} className="toggle-checkbox" />
    </div>
  );
};

export default ToggleButton;
